<template>
  <UiBtn
    :color="color"
    :size="size"
    v-bind="$attrs"
    icon="common/headphone"
    :text="c_text"
    @click="$store.dispatch('globalModal/open_globalModalSupport')"
  />
</template>

<script>
export default {
  name: 'BaseSupportButton',
  props: {
    color: { type: String, default: 'default' },
    size: { type: String, default: 's' },
    text: { type: String },
  },
  computed: {
    c_text() {
      return this.text || this.$t('supportButton')
    },
  },
}
</script>
